export const en = {
    buildings: {
        alerts: {
            create: {
                title: "Create Building",
                text: "Are you sure you want to create <b>%{building}</b>",
                success: {
                    title: "Building Created Successfully",
                    text: "<b>%{building}</b> was created successfully",
                },
                error: {
                    title: "Building Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Building",
                text: "Are you sure you want to delete <b>%{building}</b>",
                success: {
                    title: "Building Deleted Successfully",
                    text: "You will now be redirected to the buildings page",
                },
                error: {
                    title: "Building Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Building",
                text: "Are you sure you want to edit <b>%{building}</b>",
                success: {
                    title: "Building Edited Successfully",
                    text: "<b>%{building}</b> was edited successfully",
                },
                error: {
                    title: "Building Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        list: {
            name: "Name",
            parent: "Parent Entity",
            type: "Type",
            hasCheckInConfiguration: 'Check-In Control',
            openTime: 'Opens at',
            closeTime: 'Closes at'
        },
        form: {
            headers: {
                create: "Create Building",
                edit: "Edit Building",
                view: "View Building"
            },
            name: {
                label: "Name",
            },
            type: {
                label: "Type",
            },
            parent: {
                label: "Parent",
            },
            email: {
                label: "Email",
            },
            entity: {
                label: "Entity",
            },
            status: {
                label: "Status",
                enabled: "Enabled",
                disabled: "Disabled",
            },
            language: {
                label: "Language",
            },
            timezone: {
                label: "Timezone",
            },
        },
        permissions: {
            BUILDINGS: "Buildings",
            CREATE_BUILDING: "Create buildings",
            READ_BUILDING: "Read buildings",
            UPDATE_BUILDING: "Update buildings",
            DELETE_BUILDING:"Delete buildings"
        }
    }
};